import { useState, useEffect } from "react";

function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  // show button after scrolling down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    visible && (
      <button
        onClick={scrollToTop}
        style={styles.button}
      >
        ↑
      </button>
    )
  );
}

const styles = {
  button: {
    position: "fixed",
    bottom: "90px", // above WhatsApp button if you have one
    right: "25px",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    border: "none",
    background: "#333",
    color: "#fff",
    fontSize: "22px",
    cursor: "pointer",
    zIndex: 1000
  }
};

export default ScrollToTopButton;
